import type { N8NServiceSchema, N8NWorkflow } from "@/types/entities/n8n";
import axios from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";

export const useGetN8NAvailableFlows = () => {
  return useQuery({
    queryKey: ["n8n", "available-flows"],
    queryFn: async (): Promise<{
      data: N8NWorkflow[];
    }> => {
      const response = await axios.get("/admin/v1/services/n8n/workflows");
      return response.data;
    },
  });
};

export const useGetN8NFormFlows = () => {
  return useQuery({
    queryKey: ["n8n", "form-validation-flows"],
    queryFn: async (): Promise<{
      data: N8NWorkflow[];
    }> => {
      const response = await axios.get(
        "/admin/v1/services/n8n/form-validation-workflows",
      );
      return response.data;
    },
  });
};

export const getN8NFlowSchema = async (
  flowId: string,
): Promise<N8NServiceSchema> => {
  const response = await axios.get("/admin/v1/services/n8n/schemas", {
    params: {
      workflow: flowId,
    },
  });
  return response.data;
};

export const useGetN8NFlowSchema = (flowId: string) => {
  return useQuery({
    queryKey: ["n8n", "flow-schema", flowId],
    queryFn: async (): Promise<N8NServiceSchema> => {
      return getN8NFlowSchema(flowId);
    },
    enabled: !!flowId,
  });
};

export const useGetComplexRelationships = (
  expedient_base_entity_id: string,
  expedient_base_registry_id: string,
  enabled = true,
) => {
  return useQuery({
    queryKey: [
      "complex-relationships",
      expedient_base_entity_id,
      expedient_base_registry_id,
    ],
    queryFn: async (): Promise<{
      [key: string]: Array<{
        [key: string]: string | number;
      }>;
    }> => {
      const response = await axios.post(
        "/admin/v1/services/n8n/advanced-relationships",
        {
          expedient_base_entity_id,
          expedient_base_registry_id,
        },
      );
      return response.data;
    },
    enabled,
  });
};
